import React from 'react';
import ReactTable from 'react-table';

import 'react-table/react-table.css';
import 'react-picky/dist/picky.css';

const FeederDataTable = (props) => {
  return (
    <ReactTable
      columns={[
        {
          Header: () => (
            <div>
              <div className="bold-black">Updated Time</div>
            </div>
          ),
          className: 'pull-left',
          accessor: 'reportedDateTime',
          filterable: false,
          Cell: (row) => (
            <div>
              <div>{row.value.split('_')[0]}</div>
              <div>{row.value.split('_')[1]}</div>
            </div>
          ),
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">DCU Bat. Vol.</div>
            </div>
          ),
          accessor: 'dcuBatVol',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">Feeder Name</div>
            </div>
          ),
          accessor: 'deviceName',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">Ir</div>
            </div>
          ),
          accessor: 'lc_Ir',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">Iy</div>
            </div>
          ),
          accessor: 'lc_Iy',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">Ib</div>
            </div>
          ),
          accessor: 'lc_Ib',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">F-Ir</div>
            </div>
          ),
          accessor: 'fC_Ir',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">F-Iy</div>
            </div>
          ),
          accessor: 'fC_Iy',
          filterable: false,
        },
        {
          Header: () => (
            <div>
              <div className="bold-black">F-Ib</div>
            </div>
          ),
          accessor: 'fC_Ib',
          filterable: false,
        },
      ]}
      data={props.data}
      pageSize={props.data.length}
      showPagination={false}
      className="-striped -highlight faultcontentheight"
      resizable={false}
      sortable={true}
      getTdProps={() => ({
        className: 'text-center',
      })}
      getTrProps={(state, rowInfo) => {
        return {
          onClick: () => {
            props.onTableRowClick(rowInfo.row._original);
          },
          className:
            rowInfo !== undefined
              ? rowInfo.row._original.id === Number(props.selected)
                ? 'rowActive'
                : ''
              : '',
        };
      }}
      filterable
    />
  );
};
export default FeederDataTable;
